import type { Locale } from '@/i18n/types'

const backofficeRoutes = {
  editFundraisingEventInBO: '/[locale]/backoffice/fundraising_events/[slug]/edit',
  editPublicFaceInBO: '/[locale]/backoffice/users/[id]/edit',
  listDonationsInBO: '/[locale]/backoffice/donations',
} as const

const manageFundraisingEventRoutes = {
  addProjects: '/[locale]/fundraising-events/[slug]/manage/projects/search',
  editFundraisingEventManagers: '/[locale]/fundraising-events/[slug]/permissions',
  editProfilePicture: '/[locale]/fundraising-events/[slug]/manage/profile_picture/new',
  forwarding: '/[locale]/fundraising-events/[slug]/manage/forwarding',
  fundraisingEventsEdit: '/[locale]/fundraising-events/[slug]/manage/details/edit',
  thankYou: '/[locale]/fundraising-events/[slug]/manage/transaction_protocol',
  writeNews: '/[locale]/fundraising-events/[slug]/manage/blogs',
} as const

const manageProjectRoutes = {
  projectEdit: '/[locale]/projects/[slug]/manage/details/edit',
} as const

const manageOrganisationRoutes = {
  organisationDashboard: '/[locale]/manage/organisations/[slug]/dashboard',
} as const

const staticPagesRoutes = {
  aboutUsAcademy: '/c/ueber-uns/betterplace-academy?utm_source&utm_medium&utm_campaign',
  collect: (locale: Locale) => (locale === 'de' ? '/c/spenden-sammeln' : '/c/collect-donations'),
  collectAsCompany: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/als-unternehmen' : '/c/collect-donations/as-company',
  collectAsContentCreator: '/c/spenden-sammeln/creators4charity',
  collectAsOrganisation: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/als-verein' : '/c/collect-donations/as-non-profit',
  collectAsPrivatePersonAction: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/private-spendenaktion' : '/c/collect-donations/as-private-person',
  collectAsPrivatePersonFundraising: (locale: Locale) =>
    locale === 'de' ? '/c/spenden-sammeln/privater-spendenaufruf' : '/c/collect-donations/private-fundraising',
  aboutUs: '/c/ueber-uns',
  collectAsStreamer: '/c/spenden-sammeln/charity-stream',
  blog: '/c/neues',
  contactUs: '/c/kontakt',
  donationGift: '/c/neues/spendengeschenk',
  imprint: '/c/kontakt',
  itz: '/c/ueber-uns/initiative-transparente-zivilgesellschaft',
  jobs: '/c/stellen',
  legal: '/c/regeln',
  partnerPlatforms: '/c/hilfe/themen/partnerplattformen',
  popularProjects: '/[locale]/discover/44',
  press: '/c/medien',
  taxReceiptHintLink: '/c/hilfe/meine-spendenbescheinigung',
  team: '/c/unser-team',
  privacyPolicy: (locale: Locale) => (locale === 'de' ? '/c/regeln/datenschutz' : '/c/rules/privacy-policy'),
  terms: (locale: Locale) =>
    locale === 'de' ? '/c/regeln/agb/allgemeine-nutzungsbedingungen' : '/c/rules/terms/general-terms-of-use',
  charityStreamDosAndDonts: '/c/hilfe/charitystreams-dos-and-donts',
} as const

const RailsRoutes = {
  ...backofficeRoutes,
  ...manageFundraisingEventRoutes,
  ...manageProjectRoutes,
  ...manageOrganisationRoutes,
  ...staticPagesRoutes,
  askForDonationOverviewToken: '/[locale]/donation_overview_token/new',
  discovery: '/[locale]/discover?q',
  donateToBetterplace: '/[locale]/projects/7046-spende-fuer-betterplace-org-damit-wir-gemeinsam-gutes-tun-koennen',
  editUser: '/[locale]/users/[id]/edit',
  homePageSearch: '/[locale]/homepage/search',
  matchingEventsTermsAndConditions: '/[locale]/matching-events/[id]/terms-and-conditions',
  message: '/[locale]/messages/new?recipient',
  organisationDashboard: '/[locale]/manage/organisations/[slug]/dashboard',
  projectPage: '/[locale]/projects/[slug]',
  signIn: '/[locale]/users/sign_in?return_to',
  signOut: '/[locale]/users/sign_out',
  startNewFunE: '/[locale]/fundraising-events/registration/preselection?tracking_via',
  startNewProject: '/[locale]/projects/new?tracking_via',
  userDonationOverview: '/[locale]/t/user/donation_overview',
  userProfile: '/[locale]/users/[id]',
  donationOverviewToken: '/[locale]/donation_overview_token/new',
} as const

export default RailsRoutes
